import axios from "@/utils/request";

function TOKEN_DETAILS(params) {
  return axios.get("/translation/BatchTranslation/customerTokenDetails", {
    params: params
  });
}

export default {
  TOKEN_DETAILS
};
